/*
  src/redux/intro/reducer.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from 'immutability-helper';
import {
  INTRO_STARTED,
  INTRO_ADVANCED,
  INTRO_COMPLETED
} from './constants';

const initialState = {started:false,completed:false,currentStep:0};

export default function(state=initialState,action){
  switch(action.type){
  case INTRO_STARTED:
    return update(state,{$merge:{started:true}});
  case INTRO_ADVANCED:
    return update(state,{$merge:{currentStep:state.currentStep + 1,started:true}});
  case INTRO_COMPLETED:
    return update(state,{$merge:{completed:true}});
  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/intro/reducer.js